import { render, staticRenderFns } from "./FullRecentContent.vue?vue&type=template&id=096d3962&scoped=true&"
import script from "./FullRecentContent.vue?vue&type=script&lang=js&"
export * from "./FullRecentContent.vue?vue&type=script&lang=js&"
import style0 from "./FullRecentContent.vue?vue&type=style&index=0&id=096d3962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d3962",
  null
  
)

export default component.exports